import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { makeSearch } from 'shared/actions/search';
import { IFiltersUpdatedEventDetail } from 'shared/types/microfrontends';
import { TThunkDispatch } from 'shared/types/redux';
import { useApplicationContext } from 'shared/utils/applicationContext';

const EVENT_NAME = 'filters:updated';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const { microfrontendsAPI, microfrontendsRegistry } = useApplicationContext();

  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(makeSearch(detail));

      if (microfrontendsRegistry.microfrontend('search-string-micro-frontend') && microfrontendsAPI) {
        microfrontendsAPI.getSearchStringMicrofrontendAPI().setFilterJsonQuery(detail.jsonQuery);
      }
    };

    addEventListener(EVENT_NAME, onFiltersUpdated);

    return () => {
      removeEventListener(EVENT_NAME, onFiltersUpdated);
    };
  }, [dispatch, microfrontendsAPI]);
};
